import request from '@/utils/request'
import qs from 'qs'

export function getTodos(query) {
  return request({
    url: '/api/srm-base/appProcess/todoList',
    method: 'get',
    params: query
  })
}

export function opinionTask(id) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/hisInstance/v1/nodeOpinion?instId=' + id,
    method: 'get'
  })
}

export function getTaskBtn(taskId) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/getTaskBtn/' + taskId,
    method: 'get'
  })
}

export function saveVariables(processId, data) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/cockpit/activity/variables/runtime/save/' + processId,
    method: 'post',
    data
  })
}

export function getNextNode(taskId, params) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/cockpit/process-instance/getNextNode/' + taskId,
    method: 'get',
    params
  })
}

export function completeTask(data) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/task/v3/complete',
    method: 'POST',
    data: qs.stringify(data)
  })
}

export function changeActivity(data) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/cockpit/task/v1/anyway/changeActivity/' + data.taskId,
    method: 'POST',
    data: qs.stringify(data)
  })
}

export function invalidTask(id) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/history/task/v1/invalid/' + id,
    method: 'get'
  })
}

export function getBackNode(taskId) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/task/v1/getBackNode/' + taskId,
    method: 'GET'
  })
}

export function getBackNodeUser(taskId, nodeId) {
  return request({
    url: '/api/mcp-bpms-admin/a1bpmn/api/runtime/task/v1/getBackNodeUser/' + taskId + '/' + nodeId,
    method: 'GET'
  })
}

// 获取财经副总
export function getFinanceManager(query) {
  return request({
    url: '/api/coop/cmPayApply/getFinanceManager',
    method: 'get',
    params: query
  })
}

// 获取省区总经理
export function getProvinceManager(query) {
  return request({
    url: '/api/coop/cmPayApply/getProvinceManager',
    method: 'get',
    params: query
  })
}
export function getProvinceAndFinanceManagerInfoForPay(obj) {
  return request({
    url: '/api/coop/cmContractAccepteApply/getProvinceAndFinanceManagerInfoForPay',
    method: 'post',
    data: obj
  })
}

// 加载财总和省总信息
export function getProvinceAndFinanceManagerInfo(obj) {
  return request({
    url: '/api/coop/cmContractAccepteApply/getProvinceAndFinanceManagerInfo',
    method: 'post',
    data: obj
  })
}
export function getStruByPurgrp(query) {
  return request({
    url: '/api/srm-base/struPurgrp/getStruByPurgrp',
    method: 'get',
    params: query
  })
}

// 获取品类采购组审批人
export function getCatgPurgrp(query) {
  return request({
    url: '/api/coop/cmPayApply/getCatgPurgrp',
    method: 'get',
    params: query
  })
}

// 流程终止
export function invalid(id) {
  return request({
    url: '/api/coop/cmPayApply/invalid/' + id,
    method: 'get'
  })
}
